/**
 * Newsletter teaser on small viewports (in Shop-Checkout 5).
 * @module NewsletterTeaser
 * @return {Object} public methods.
 */
const NewsletterTeaser = (function () {
    var $win;
    var $doc;
    var $newsletterInfo;
    var $newsletterInfoWrapper;
    var $closeButton;
    var $teaserText;
    var $footer;

    function init() {
        $newsletterInfo = $('.newsletter-info');

        if ($newsletterInfo.length === 0) return false;

        getDOMElements();
        addEventListener();
        handleSticky();
        handlePosition();
    }

    function getDOMElements() {
        $win = $(window);
        $doc = $(document);
        $newsletterInfoWrapper = $('.newsletter-info__wrapper-bottom');
        $closeButton = $('.newsletter-info .newsletter-info__close');
        $teaserText = $('.checkout-fin');
        $footer = $('.footer');
    }

    function addEventListener() {
        $closeButton.on('click', onCloseButtonClick);
        $doc.on('scroll', onDocumentScroll);
        $win.on('resize', onWindowResize, false);
    }

    function onCloseButtonClick() {
        $newsletterInfo.addClass('closed');
        $newsletterInfo.removeClass('fixed');
        $closeButton.hide();
        return false;
    }

    function onDocumentScroll() {
        handleSticky();
    }

    function onWindowResize() {
        handlePosition();
    }

    function handleSticky() {
        if ($newsletterInfo.length === 0 || $newsletterInfo.hasClass('closed') || !matchMedia('only screen and (max-width: 751px)').matches) return false;

        var st = $win.scrollTop();
        var scrollBottom;

        if (st >= lastScrollTop) {
            scrollBottom = $win.height() + st;

            if ($newsletterInfoWrapper.offset()['top'] + $newsletterInfo.outerHeight() + ($newsletterInfoWrapper.outerHeight() - $newsletterInfo.outerHeight()) < scrollBottom) {
                if ($newsletterInfo.is(':visible')) {
                    $newsletterInfo.removeClass('fixed');
                    $closeButton.hide();
                }
                if (!$newsletterInfo.hasClass('fixed')) {
                    $newsletterInfo.show();
                    $closeButton.hide();
                }
            }
            if ($footer.offset()['top'] + 100 < $doc.height() || st > 100) {
                if (!$newsletterInfo.is(':visible')) {
                    $newsletterInfo.addClass('fixed');
                    $newsletterInfo.velocity("slideDown", { duration: 300 });
                }
            }
        }
        lastScrollTop = st;
    }

    function handlePosition() {
        if ($newsletterInfo.length === 0 || $newsletterInfo.hasClass('closed')) return false;


        if (matchMedia('only screen and (max-width: 751px)').matches) {
            if ($newsletterInfo.parent('.checkout-fin > .right').length > 0) {
                $newsletterInfoWrapper.css('height', $newsletterInfo.outerHeight());
                $newsletterInfoWrapper.append($newsletterInfo);
            }
        } else {
            if($newsletterInfo.parent('.checkout-fin > .right').length == 0){
                $teaserText.children('.right').append($newsletterInfo);
                $newsletterInfoWrapper.css('height', 0);
            }
        }
    }

    // Return public methods
    return {
        init: init
    };
})();

window.NewsletterTeaser = NewsletterTeaser;
export default NewsletterTeaser;
